import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  CONTRACT_FORM_CONTRACT_ID_MAX_LENGTH,
  CONTRACT_FORM_FIELD_NAME_CONTRACT_ID,
} from '../../../Contract.constants'

function ContractIdField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Contract.ContractIdLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={CONTRACT_FORM_CONTRACT_ID_MAX_LENGTH}
      name={CONTRACT_FORM_FIELD_NAME_CONTRACT_ID}
      placeholder={t('Contract.ContractIdPlaceholderKey')}
    />
  )
}

export default ContractIdField
